import React from 'react';
import OnMountAndUpdate from '@atlassian/jira-common-util-op-triggers/src/on-mount-and-update/OpTrigger.tsx';
import { subProductFromProjectTypeForAnalytics } from '@atlassian/jira-subproduct/src/index.tsx';
import TagMauEvent from '../../tag-mau/index.tsx';
import setCurrentSubProduct from './set-current-sub-product-and-solutions.tsx';
import { isSubProductProps, type Props } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { Props };

export const SubProductUpdater = ({
	allowMonolithDeferral = false,
	...props
}: Props): React.JSX.Element => {
	const subProduct = isSubProductProps(props)
		? props.subProduct
		: subProductFromProjectTypeForAnalytics(props.projectType);

	return (
		<>
			<OnMountAndUpdate op={setCurrentSubProduct} args={[subProduct, allowMonolithDeferral]} />
			<TagMauEvent subProduct={subProduct} />
		</>
	);
};
